module.exports = __webpack_public_path__ + "media/images/app/products/index/occassions/date-night-f44ccc4047b41eebf92959c6d8a61757.webp";